import { IContractorMotivationDTO, IContractorMotivationEditDTO, IContractorMotivationViewDTO } from "../../coreapi-dto/dirs/contractorsMotivation";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


class ContractorMotivationRequest extends BaseDirRequest<IContractorMotivationViewDTO, IContractorMotivationDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "contractorMotivation", token, eventHandler)
    }

    getByIdContractorGlobal(idGlobal: string, callback: (e: CoreApiResponse<IContractorMotivationDTO>) => void) {
        super.get<IContractorMotivationDTO>(`${this._baseUrl}/${this._routePrefix}/GetByIdContractorGlobal/${idGlobal}`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    updateByIdContractorGlobal (idGlobal: string, body: IContractorMotivationEditDTO, callback: (e: CoreApiResponse<null>) => void) {
        super.put(`${this._baseUrl}/${this._routePrefix}/${idGlobal}`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    createByIdContractorGlobal(body: IContractorMotivationEditDTO, callback: (e:CoreApiResponse<string>) => void) {
        super.post<string>(`${this._baseUrl}/${this._routePrefix}`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
        }
    
}

export default ContractorMotivationRequest